import React from 'react';
import { useTranslation } from '@shared/core';
import { Flex, TextV2 } from '@withjoy/joykit';
import { Info } from '@withjoy/joykit/icons';

export const SoldOutMessage = () => {
  const { t } = useTranslation('accommodationsConsole');
  const listingTrans = t('listingsPanel');

  return (
    <Flex
      width={'100%'}
      gap={3}
      alignItems="center"
      color="negative6"
      marginTop={{ _: 0, md: 5 }}
    >
      <Info size={16} />
      <TextV2 typographyVariant={'label2'}>{listingTrans.soldOutMessage()}</TextV2>
    </Flex>
  );
};
